/* eslint-disable quotes */
export default [
  {
    title: {
      it: 'Fonti per le attività culturali',
      en: 'Fonti per le attività culturali'
    },
    value: 6862155,
    key: 'funds',
    color: '#18C8B5',
    items: [
      {
        id: 0,
        title: {
          it: 'Gestioni finanziarie',
          en: 'Gestioni finanziarie'
        },
        value: 1446006
      },
      {
        id: 1,
        title: {
          it: 'Proventi da partecipazioni',
          en: 'Proventi da partecipazioni'
        },
        value: 527474
      },
      {
        id: 2,
        title: {
          it: 'Contributi ed entrate occasionali',
          en: 'Contributi ed entrate occasionali'
        },
        value: 3479424
      },
      {
        id: 3,
        title: {
          it: 'Valore aggiunto da esercizi precedenti',
          en: 'Valore aggiunto da esercizi precedenti'
        },
        value: 1556444
      },
      {
        id: 4,
        title: {
          it: 'Fiscalità',
          en: 'Fiscalità'
        },
        value: -147193
      }
    ]
  },
  {
    title: {
      it: 'Costi di struttura',
      en: 'Costi di struttura'
    },
    value: -626244,
    key: 'costs',
    color: '#E95263',
    items: [
      {
        id: 5,
        title: {
          it: 'Spese di funzionamento',
          en: 'Spese di funzionamento'
        },
        value: -523900
      },
      {
        id: 6,
        title: {
          it: 'Spese straordinarie',
          en: 'Spese straordinarie'
        },
        value: -99592
      },
      {
        id: 7,
        title: {
          it: 'Ammortamenti',
          en: 'Ammortamenti'
        },
        value: -2752
      }
    ]
  },
  {
    title: {
      it: 'Valore aggiunto prodotto',
      en: 'Valore aggiunto prodotto'
    },
    value: 6235911,
    key: 'total',
    color: '#7C4EBB',
    items: [
      {
        id: 8,
        title: {
          it: 'Ricerca',
          en: 'Ricerca'
        },
        value: 815846
      },
      {
        id: 9,
        title: {
          it: 'Attività per l’istruzione',
          en: 'Attività per l’istruzione'
        },
        value: 4553067
      },
      {
        id: 10,
        title: {
          it: 'Azioni di solidarietà sociale',
          en: 'Azioni di solidarietà sociale'
        },
        value: 421668.0
      },
      {
        id: 11,
        color: '#7C4EBB',
        title: {
          it: 'V.A. distribuito nell’esercizio',
          en: 'V.A. distribuito nell’esercizio'
        },
        value: 5790581.0
      },
      {
        id: 12,
        color: '#7C4EBB',
        title: {
          it: 'V.A. per attività future e avanzo',
          en: 'V.A. per attività future e avanzo'
        },
        value: 445330
      }
    ]
  }
];
